// extracted by mini-css-extract-plugin
module.exports = {"main-menu":"styles_main-menu__3fsjI","menu-item":"styles_menu-item__1RAEg"};